import { z } from 'zod';

/**
 * Bounded processing outcomes for Public API HTTP audit records.
 * Describes how Nexus handled the operation — not a restatement of HTTP status.
 */
export const PUBLIC_API_AUDIT_OUTCOMES = [
  'TOKEN_ISSUED',
  'AUTHENTICATION_FAILED',
  'ACCESS_DENIED',
  'VALIDATION_FAILED',
  'MARKETS_RETURNED',
  'UPLOAD_CREATED',
  'UPLOAD_CONFIRMED',
  'UPLOAD_CONFIRM_FAILED',
  'JOB_ACCEPTED',
  'IDEMPOTENT_REPLAY',
  'JOB_STATUS_RETURNED',
  'JOB_RESULTS_RETURNED',
  'RESOURCE_NOT_FOUND',
  'ENQUEUE_FAILED',
  'IDEMPOTENCY_CONFLICT',
  'RATE_LIMITED',
  'INTERNAL_ERROR',
] as const;

export type PublicApiAuditOutcome = (typeof PUBLIC_API_AUDIT_OUTCOMES)[number];

export const PublicApiAuditOutcomeEnum = z.enum(PUBLIC_API_AUDIT_OUTCOMES);

/** Cloud Logging / Pino message used to find Public API audit records. */
export const PUBLIC_API_AUDIT_LOG_MESSAGE = 'public_api.audit' as const;

/**
 * Allow-listed Public API audit record. Never add headers, bodies, tokens,
 * cookies, or signed URLs — only the fields declared here.
 */
export const PublicApiAuditRecordSchema = z.object({
  kind: z.literal('public_api'),
  timestamp: z.string(),
  correlationId: z.string(),
  method: z.string(),
  route: z.string(),
  statusCode: z.number().int(),
  outcome: PublicApiAuditOutcomeEnum,
  durationMs: z.number(),
  callerId: z.string().optional(),
  tenantId: z.string().optional(),
  uploadId: z.string().optional(),
  jobId: z.string().optional(),
});

export type PublicApiAuditRecord = z.infer<typeof PublicApiAuditRecordSchema>;
